/**
 * @copyright Copyright (c) 2016, Pacific Biosciences of California, Inc.
 * @author <a href="mailto:dbarreto@pacificbiosciences.com">David Barreto</a>
 */

import {commonTranslations} from "./common"

export const welcomeTranslations = {
    title: commonTranslations.home,
    signIn: "Sign In",
    welcomeTo: "Welcome to",
    welcomeToSmrtLink: "Welcome to SMRT Link",
    welcomeToSmrtLinkHtml: "<p>Welcome to</p><h1>SMRT<sup>&#174;</sup> Link</h1>"
}
